import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Layers } from "lucide-react";

export const HomeCTASection = () => (
  <section className="bg-[#0A192F] py-20 sm:py-24" data-testid="home-cta-banner">
    <div className="max-w-5xl mx-auto px-5 sm:px-6 lg:px-10 text-center">
      <Layers size={28} className="text-[#D4AF37] mx-auto" />
      <h2 className="mt-5 sm:mt-6 font-display font-black text-white text-3xl sm:text-4xl lg:text-5xl tracking-tighter">
        Ready to stock your next build?
      </h2>
      <p className="mt-4 sm:mt-5 text-white/75 max-w-2xl mx-auto text-sm sm:text-base">
        Tell us about your project - lumber takeoffs, steel packages, or a complete material
        list. We&apos;ll turn it around quickly with accurate pricing and clear timing.
      </p>
      <Link
        to="/contact"
        data-testid="bottom-cta-quote"
        className="mt-7 sm:mt-10 inline-flex w-full sm:w-auto items-center justify-center gap-3 bg-[#D4AF37] text-[#0A192F] px-8 sm:px-10 py-4 sm:py-5 font-display text-xs uppercase tracking-[0.2em] sm:tracking-[0.3em] font-bold hover:bg-white transition-colors"
      >
        Start Your Quote <ArrowRight size={16} />
      </Link>
    </div>
  </section>
);

export default HomeCTASection;
